const PropTypes = require('prop-types');
// @vendors
const React = require('react');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ local
const { BrokerAdvancedSearchWarrantsResultsRow } = require('./warrantsResultsRow');

class BrokerAdvancedSearchWarrantsResultsTable extends React.Component {
    constructor(props) {
        super(props);

        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    handleProductSelect(product) {
        this.props.onHandleProductSelect(product);
    }

    tableHeaders() {
        const PREFIX = 'broker-searchResults';
        const nameLabel = formatText(`${PREFIX}NameLabel`);
        const typeLabel = formatText(`${PREFIX}TypeLabel`);
        const underlyingLabel = formatText(`${PREFIX}UnderlyingLabel`);
        const callPutLabel = formatText(`${PREFIX}CallPutLabel`);
        const exercisePriceLabel = formatText(`${PREFIX}ExercisePriceLabel`);
        const issuerLabel = formatText(`${PREFIX}IssuerLabel`);
        const expirationLabel = formatText(`${PREFIX}ExpirationLabel`);

        return (
            <OKTableRow asHeader={true} className="broker-search-results__table-header">
                <OKTableCell
                    asHeader={true}
                    className="broker-search-results__table-first-column"
                    width="20%"
                >
                    {nameLabel}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    width="8%"
                >
                    {typeLabel}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    width="10%"
                >
                    {underlyingLabel}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="broker-search-results__table-cell--left-padding"
                    width="8%"
                >
                    {callPutLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    asHeader={true}
                    className="broker-search-results__table-header-cell--warrants-price"
                    width="5%"
                >
                    {exercisePriceLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="center"
                    asHeader={true}
                    width="10%"
                >
                    {issuerLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    asHeader={true}
                    width="6%"
                >
                    {expirationLabel}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="broker-search-results__table-header-cell--warrant-action"
                    width="8%"
                />
            </OKTableRow>
        );
    }

    tableRows(results) {
        const tableRows = results.map((result,index) => {
            const uniqueId = result.get('productKey');
            return this.props.isModal
                ? <BrokerAdvancedSearchWarrantsResultsRow
                    key={uniqueId}
                    item={result}
                    isModal={this.props.isModal}
                    onHandleProductSelect={this.handleProductSelect}
                    onBuyClick={this.props.onHandleProductBuy}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}
                    watchlistEnabled={this.props.watchlistEnabled}
                  />
                : <BrokerAdvancedSearchWarrantsResultsRow
                    key={uniqueId}
                    item={result}
                    onBuyClick={this.props.onHandleProductBuy}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}
                    watchlistEnabled={this.props.watchlistEnabled}
                 />;
        });

        return tableRows;
    }

    render() {
        const { results } = this.props;

        const tableHeaders = this.tableHeaders();
        const tableRows = this.tableRows(results);

        /**
         * @horizontal-scroll
         *
         * The result table has a container with an horizontal scroll and the
         * inner content is set to a fix width according to its size in
         * desktop.
         */

        return (
            <div className="broker-search-results__table-wrapper" style={{ overflowX: 'auto' }}>
                <OKTable className="broker-search-results__table">
                    <thead>
                        {tableHeaders}
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                </OKTable>
            </div>
        );
    }
}

BrokerAdvancedSearchWarrantsResultsTable.propTypes = {
    results: PropTypes.object,
    isModal: PropTypes.bool,
    onHandleProductSelect: PropTypes.func,
    onHandleProductBuy: PropTypes.func,
    onHandleWatchlistAdd: PropTypes.func,
    deleteProductFromList: PropTypes.func,
    watchlistEnabled: PropTypes.bool,
};

module.exports = BrokerAdvancedSearchWarrantsResultsTable;
